import PropTypes from "prop-types";
import MDBox from "components/MDBox";

const dotSx = (delay, size, color) => ({
  width: size,
  height: size,
  borderRadius: "50%",
  backgroundColor: color,
  opacity: 0.25,
  animation: "thinking-spinner-pulse 0.9s ease-in-out infinite",
  animationDelay: delay,
});

function ThinkingSpinner({ size, color, gap }) {
  return (
    <MDBox
      component="span"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      gap={gap}
      sx={{
        "@keyframes thinking-spinner-pulse": {
          "0%, 80%, 100%": {
            transform: "scale(0.75)",
            opacity: 0.2,
          },
          "40%": {
            transform: "scale(1)",
            opacity: 0.9,
          },
        },
      }}
    >
      <MDBox component="span" sx={dotSx("0s", size, color)} />
      <MDBox component="span" sx={dotSx("0.12s", size, color)} />
      <MDBox component="span" sx={dotSx("0.24s", size, color)} />
    </MDBox>
  );
}

ThinkingSpinner.defaultProps = {
  size: 6,
  color: "currentColor",
  gap: 0.5,
};

ThinkingSpinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  gap: PropTypes.number,
};

export default ThinkingSpinner;